import { OPEN_METEO_URL } from './providers'

export interface DailyForecast {
  date: string
  code: number
  tMax: number
  tMin: number
  precipMm: number
  precipProb: number
  windMax: number
}

export const WEATHER_ICONS: [number[], string, string][] = [
  [[0], '☀️', 'Clear'],
  [[1, 2], '🌤️', 'Mostly clear'],
  [[3], '☁️', 'Overcast'],
  [[45, 48], '🌫️', 'Fog'],
  [[51, 53, 55, 56, 57], '🌦️', 'Drizzle'],
  [[61, 63, 65, 66, 67, 80, 81, 82], '🌧️', 'Rain'],
  [[71, 73, 75, 77, 85, 86], '🌨️', 'Snow'],
  [[95, 96, 99], '⛈️', 'Thunderstorm'],
]

export function weatherInfo(code: number): { icon: string; label: string } {
  const hit = WEATHER_ICONS.find(([codes]) => codes.includes(code))
  return hit ? { icon: hit[1], label: hit[2] } : { icon: '☁️', label: 'Cloudy' }
}

export async function fetchForecast(lat: number, lng: number, signal?: AbortSignal): Promise<DailyForecast[]> {
  const url = new URL(OPEN_METEO_URL)
  url.searchParams.set('latitude', lat.toFixed(3))
  url.searchParams.set('longitude', lng.toFixed(3))
  url.searchParams.set(
    'daily',
    'weather_code,temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max,wind_speed_10m_max',
  )
  url.searchParams.set('forecast_days', '7')
  url.searchParams.set('timezone', 'auto')
  const res = await fetch(url, { signal })
  if (!res.ok) return []
  const data = (await res.json()) as {
    daily?: {
      time: string[]
      weather_code: number[]
      temperature_2m_max: number[]
      temperature_2m_min: number[]
      precipitation_sum: number[]
      precipitation_probability_max: (number | null)[]
      wind_speed_10m_max: number[]
    }
  }
  const d = data.daily
  if (!d) return []
  return d.time.map((date, i) => ({
    date,
    code: d.weather_code[i],
    tMax: Math.round(d.temperature_2m_max[i]),
    tMin: Math.round(d.temperature_2m_min[i]),
    precipMm: d.precipitation_sum[i],
    precipProb: d.precipitation_probability_max[i] ?? 0,
    windMax: Math.round(d.wind_speed_10m_max[i]),
  }))
}
